import React from 'react';

import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import isEmpty from 'lodash/isEmpty';
import { bindActionCreators } from 'redux';
import { withAlert } from 'react-alert';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import PropTypes from 'prop-types';
import { Auth } from 'aws-amplify';
import 'react-phone-number-input/style.css';
import 'react-responsive-ui/style.css';
// import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { Table, TableBody, TableCell, TableHead, TableRow, 
  // TablePagination, 
  withStyles } from '@material-ui/core';

// import ReactTable from 'react-table';
import 'react-table/react-table.css';
import { Link } from 'react-router-dom';
import Validator from 'validator';
import * as Modal from 'react-modal';
import loader from '../../images/Spin-1s-107px.gif';
import MaskInputNumber from '../common/maskInputNumberProfile';
import SubuserUpdateAffiliate from '../affiliateComponents/subuserAffiliate/subuserUpdateAffiliate';
import {
  getStates,
  getAffiliateUser,
  deleteAffiliatedSubUser,
  getAllAffiliatedUsers,
  updateAffiliate,
  getAllCountry,
  getCityByStateId,
  updateConsumerUser,
  getAllStates,
  checkEmailVerify,
} from '../../Actions/actions';
import TextFieldGroupProfile from '../common/TextFieldGroupProfile';
import ChangePassword from '../common/changePassword';

const CustomTableCell = withStyles(theme => ({
  head: {
      backgroundColor: '#fff',
      color: '#525659',

  },
  body: {
      fontSize: 14,

  },
}))(TableCell);


const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

class Profile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: '',
      lastName: '',
      state: '',
      phoneNumber: '',
      affiliateType: '',
      email: '',
      cognitoId: '',
      oldEmail: '',
      cityId: '',
      stateId: '',
      countryId: '',
      errors: {},
      stateSuccess: '',
      cCountryCode: '+1',
      countryName: 'US',
      companyName: '',
      companyPostion: '',
      zipCode: '',
      streetAddressOne: '',
      streetAddressTwo: '',
      isLoader: false,
      updateProfileDateA1: [],
      AffilateUpdateProfileDataStatus: false,
      GetAffiliateSubUserList1: [],
      modalIsOpenAffiliateDelete: false,
      deleteAffId: '',
      listData: '',
      deleteStatusA: false,
      intervalId: 0,
      parentPartnerId: '',
      // rowsPerPage: 10,
      // pageNumber: 0,
            

    };
    this.onChange = this.onChange.bind(this);
    this.onChange1 = this.onChange1.bind(this);
    this._cSelect = this._cSelect.bind(this);
    this._countrySelect = this._countrySelect.bind(this);
    this.handleSubmitAffiliate = this.handleSubmitAffiliate.bind(this);
    this.handleSeletcedYearChangeConsumer = this.handleSeletcedYearChangeConsumer.bind(
      this,
    );
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this._cCountrySelect = this._cCountrySelect.bind(this);
    this.handleClickOpenDelete = this.handleClickOpenDelete.bind(this);
    this.closeModalAffiliateDelete = this.closeModalAffiliateDelete.bind(this);
    this.handleDeleteYAffiliate = this.handleDeleteYAffiliate.bind(this);
  }

  onChange1(e) {
    const re = /^[a-zA-Z]*$/;
    if (re.test(e.target.value)) {
      this.setState({ [e.target.name]: e.target.value, errorsTermPolicy: {} });
    }
  }

  /**
   * set values on imput change
   * @param {event} e
   */
  onChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
      errors: {},
      errorsTermPolicy: {},
      errorsCompany: {},
    }, () => { if (this.state.email !== '') { this.props.checkEmailVerify({ email: this.state.email }); } });
  }

  scrollStep = () => {
    if (window.pageYOffset === 0) {
      clearInterval(this.state.intervalId);
    }
    window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
  }

  _cSelect(e) {
    this.setState({ stateId: e.value });
  }

  /**
   * on Country select
   * @param {event} e
   */
  _countrySelect(e) {
    this.setState({ countryName: e.value });
  }

  _cCountrySelect(e) {
    this.setState({ cCountryCode: e.value });
  }

  /**
   * Load Initial States and Load Affiliate Users
   */
  componentDidMount() {
    this.props.getAllStates();
    this.props.getAffiliateUser(localStorage.getItem('userId'));
    this.props.getAllAffiliatedUsers();
  }

  /**
   * On Delete Popup
   */
  handleClickOpenDelete(id, value) {
    this.setState({
      modalIsOpenAffiliateDelete: true,
      deleteAffId: id,
      listData: value
    });
  }

  /**
   * Close Delete Modal
   */
  closeModalAffiliateDelete() {
    this.setState({ modalIsOpenAffiliateDelete: false });
  }

  handleDeleteYAffiliate() {
    this.setState({
      deleteStatusA: true,
      isLoader: true,
      modalIsOpenAffiliateDelete: false,
    });

    const data = {
      id: this.state.deleteAffId,
      cognitoClientId: this.state.listData && this.state.listData.cognitoId
    };
    this.props.deleteAffiliatedSubUser(data);
  }

  componentWillMount() {
    const intervalId = setInterval(this.scrollStep.bind(this), this.props.delayInMs);
    this.setState({
      intervalId,
    });
    this.props.getAllCountry();

    Auth.currentUserInfo()
      .then((res) => {
        this.setState({
          roleName: res.attributes['custom:roleName'],
        });
        const Fname = res.attributes['custom:first_name'];
        const Lname = res.attributes['custom:last_name'];
        const name = `${Fname} ${Lname}`;
        this.setState({ UserName: name });
      })
      .catch(error => error);
  }

  componentDidUpdate() {
    const {
      GetAffiliateUser,
      GetDeletedAffiliateSubUser,
      updateProfileDateA,
      GetAffiliateSubUserList,
    } = this.props.data;
    const {
      stateSuccess,
      updateProfileDateA1,
      GetAffiliateSubUserList1,
      parentPartnerId
    } = this.state;
    if((GetAffiliateUser && GetAffiliateUser.parentPartnerId) && (GetAffiliateUser.parentPartnerId != parentPartnerId)){
      this.setState({
        parentPartnerId: GetAffiliateUser.parentPartnerId
      })
    }

    if (this.state.deleteStatusA === true) {
      if (GetDeletedAffiliateSubUser === 200) {
        setTimeout(() => {
          this.props.getAllAffiliatedUsers();
        }, 2000);
        this.setState({ deleteStatusA: false });
      }
    }

    if (GetAffiliateSubUserList1 !== GetAffiliateSubUserList) {
      this.setState({
        GetAffiliateSubUserList1: GetAffiliateSubUserList,
        isLoader: false,
      });
    }

    
    if (stateSuccess !== GetAffiliateUser) {
    if(GetAffiliateUser ) {
      this.setState({
        userId:  GetAffiliateUser.userId,
        firstName: GetAffiliateUser.firstName,
        lastName: GetAffiliateUser.lastName,
        phoneNumber: GetAffiliateUser.phoneNumber,
        affiliateType: GetAffiliateUser.affiliateType,
        email: GetAffiliateUser.email,
        oldEmail: GetAffiliateUser.email,
        cognitoId: GetAffiliateUser.cognitoId,
        cityId: GetAffiliateUser.city,
        stateId: GetAffiliateUser.stateId,
        countryId: GetAffiliateUser.countryId,
        affiliateUserId: GetAffiliateUser.affiliateUserId,
        cCountryCode: GetAffiliateUser.countryCode,
        companyName: GetAffiliateUser.companyName,
        companyPostion: GetAffiliateUser.companyPostion,
        zipCode: GetAffiliateUser.zipCode,
        streetAddressOne: GetAffiliateUser.streetAddressOne,
        streetAddressTwo: GetAffiliateUser.streetAddressTwo,
        stateSuccess: GetAffiliateUser,
      });
      if (GetAffiliateUser.countryId !== '') { this.props.getStates(GetAffiliateUser.countryId); }
    }
    }

    if (updateProfileDateA !== undefined) {
      if (updateProfileDateA1 !== updateProfileDateA) {
        this.setState({
          isLoader: false,
          updateProfileDateA1: updateProfileDateA,
        });
        // toast.info('Profile updated successfully!', {
        //   position: toast.POSITION.TOP_CENTER,
        // });
      }
    }
  }

  /**
   * Check If Valid Affliate
   */
  isValidAffiliate() {
    const { errors, isValidAffiliate } = this.validateInputConsumer(this.state);

    if (!isValidAffiliate) {
      this.setState({ errors });
    }
    return isValidAffiliate;
  }

  /**
   * Form Validation
   */
  validateInputConsumer(data) {
    const errors = {};
    if (!data.firstName) {
      errors.firstName = 'First name is required';
      errors.firstNameError = true;
    } else if (data.firstName.length < 2 || data.firstName.length > 20) {
      errors.firstName = "First name should be between 2 to 20 characters";
      errors.firstNameError = true;
    }

    if (!data.lastName) {
      errors.lastName = 'Last name is required';
      errors.lastNameError = true;
    }  else if (data.lastName.length < 2 || data.lastName.length > 20) {
      errors.lastName = "Last name should be between 2 to 20 characters";
      errors.lastNameError = true;
    }

    if (!data.companyName) {
      errors.companyName = 'Company name is required';
      errors.companyNameError = true;
    } else if (data.companyName.length < 2 || data.companyName.length > 50) {
      errors.companyName =
        "Company Name and DBA should be between 2 to 50 characters";
      errors.companyNameError = true;
    }

    if (!data.companyPostion) {
      errors.companyPostion = 'Company postion is required';
      errors.companyPostionError = true;
    }
    if (!data.streetAddressOne) {
      errors.streetAddressOne = 'Street address is required';
      errors.streetAddressOneError = true;
    }
    if (!data.zipCode) {
      errors.zipCode = 'Zip code is required';
      errors.zipCodeError = true;
    }
    //
    if (!data.phoneNumber) {
      errors.phoneNumber = 'Mobile number is required';
      errors.phoneNumberError = true;
    }
    if (!data.phoneNumber) {
      errors.phoneNumber = 'Mobile number is required';
      errors.phoneNumberError = true;
    } else if (data.phoneNumber.replace(/\s/g, '').replace(/[_-]/g, '').length !== 10) {
      errors.phoneNumber = 'Please enter at least 10 digit';
      errors.phoneNumberError = true;
    }
    if (data.email !== '') {
      const isemailVerified = this.props.data.emailVerifyData;
      if (this.state.email !== this.state.oldEmail) {
        if (Object.keys(isemailVerified).length > 0) {
          if (isemailVerified.collectMessage.messageShort === 'User email already exist') {
            errors.email = 'This user\'s email address has already been added to Collectively';
          }
        }
      }
    }

    if (!Validator.isEmail(data.email)) {
      errors.email = 'Email is Not Valid';
      errors.emailError = true;
    }

    if (!data.cityId) {
      errors.cityId = 'City is required';
      errors.cityIdError = true;
    }

    if (data.stateId === '') {
      errors.stateId = 'State is required';
      errors.stateIdError = true;
    }
    if (data.countryName === '') {
      errors.countryName = 'Country is required';
      errors.countryNameError = true;
    }

    return {
      errors,
      isValidAffiliate: isEmpty(errors),
    };
  }

  /**
   * On Submit Form
   */
  handleSubmitAffiliate(e) {
    e.preventDefault();
    if (this.isValidAffiliate()) {
      this.setState({
        errors: {},
        isLoader: true,
        isLoading: true,
      });
      this.props.updateAffiliate(this.state);
    }
  }

  AckOnchange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleSeletcedYearChangeConsumer(date) {
    this.setState({ cSince: date });
  }

  /**
   * Open Modal
   */
  openModal() {
    this.setState({ modalIsOpen: true });
  }

  /**
   * Close Modal
   */
  closeModal() {
    this.setState({ modalIsOpen: false });
  }

//   handleChangePage = (event, newPage) => {
//     this.setState({
//         pageNumber: parseInt(newPage, 10)
//     }, () => {
//         // this.fetchData()
//     })
// };

// handleChangeRowsPerPage = (event) => {
//     this.setState({
//         rowsPerPage: parseInt(event.target.value, 10)
//     }, () => {
//         // this.fetchData()
//     })
// };


  render() {
    const {
      errors,
      email,
      GetAffiliateSubUserList1,
      zipCode,
      isLoader,
      companyName,
      companyPostion,
      streetAddressOne,
      streetAddressTwo,
      cCountryCode,
      countryName,
      phoneNumber,
      affiliateType,
      cityId,
      stateId,
      firstName,
      lastName,
      parentPartnerId
      // rowsPerPage,
      // pageNumber,
            
    } = this.state;
    const { AllStates, AllCountryData, AllStateData } = this.props.data;
    const userObject = JSON.parse(localStorage.getItem("userObject"));
    const options = [];
    options.push({ value: '', label: 'State', name: 'state' });
    AllStates.map(item => options.push({
      value: item.stateId,
      label: item.stateName,
      name: item.stateName,
    }));

    const optionsCountry1 = [];
    optionsCountry1.push({ value: '', label: 'Country', name: 'Country' });

    AllCountryData.map(item => optionsCountry1.push({
      value: item.countryName,
      label: item.countryName,
      name: item.countryName,
    }));
    const optionsCountry = [];
    if (AllCountryData !== undefined) {
      AllCountryData.map(item => optionsCountry.push({
        value: item.countryCode,
        label: item.countryCode,
        name: item.countryCode,
      }));
    } else {
      optionsCountry.push({ value: '+1', label: '+1', name: '+1' });
    }
    const cSelectedCountry = _.find(optionsCountry, { value: cCountryCode });
    const cDefaultOptionCountry = cSelectedCountry;

    const optionsState = [];
    optionsState.push({ value: '', label: 'State', name: 'State' });
    if (AllStateData !== undefined) {
      AllStateData.map(item => optionsState.push({
        value: item.stateId,
        label: item.stateName,
        name: item.stateName,
      }));
    }

    const cSelectedCountry1 = _.find(optionsCountry1, { value: countryName });
    const cDefaultOptionCountry1 = cSelectedCountry1;

    const cSelectedState = _.find(optionsState, { value: stateId });
    const cDefaultOptionState = cSelectedState;

    let loader1;
    if (isLoader) {
      loader1 = (
        <div className="loader">
          <img src={loader} alt="" />
        </div>
      );
    }
    return (
      <span>
        {loader1}
        { localStorage.getItem('roleName') !== "Affiliate-SubUser" ? (
          <div>
        <Modal
          shouldCloseOnOverlayClick={false}
          isOpen={this.state.modalIsOpenAffiliateDelete}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModalAffiliateDelete}
          style={customStyles}
          contentLabel="test"
          ariaHideApp={false}
        >
          <div className="modal-content addvehicle-content">
            <div className="col s12 m7">
              <h4> Delete User</h4>
            </div>
            <div className="col s12">
              <div className="grey-box">
                <div className="grey-inner">
                  <p> Are you sure you want to delete the user?</p>
                  <button
                    onClick={this.handleDeleteYAffiliate}
                    className="btn waves-effect waves-light primary-btn col s12 m6 offset-m3 update-profile"
                    type="submit"
                    name="action"
                  >
                    Yes
                    <i className="material-icons">arrow_forward</i>
                  </button>

                  <button
                    onClick={this.closeModalAffiliateDelete}
                    style={{ marginLeft: '5px' }}
                    className="btn waves-effect waves-light primary-btn col s12 m6 offset-m3 update-profile"
                    type="submit"
                    name="action"
                  >
                    No
                    <i className="material-icons">arrow_forward</i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>

        {/* <ToastContainer /> */}

        <div className="row section-content">
          <div>
            <div className="row partner-profile">
              <div className="col s12  profileseting-formtop">
                <form onSubmit={this.handleSubmitAffiliate}>
                  <div className="row  profile-formmain">
                    <div className="tab-inner">
                    <div className="col-12 s6">
                      <div className="row">
                        <h4 col s12 m9> Account Information </h4>

                        <div className="input-field col s12 l6">
                          <TextFieldGroupProfile
                            field="firstName"
                            value={firstName}
                            label="First Name*"
                            error={errors.firstName}
                            onChange={this.onChange}
                          />
                        </div>

                        <div className="input-field col s12 l6">
                          <TextFieldGroupProfile
                            field="lastName"
                            value={lastName}
                            error={errors.lastName}
                            label="Last Name*"
                            onChange={this.onChange}
                          />
                        </div>
                        <div className="input-field col s12">
                          <TextFieldGroupProfile
                            field="companyName"
                            value={companyName}
                            error={errors.companyName}
                            label="Company Name*"
                            onChange={this.onChange}
                          />
                        </div>
                        <div className="input-field col s12">
                          <TextFieldGroupProfile
                            field="companyPostion"
                            value={companyPostion}
                            error={errors.companyPostion}
                            label="Position*"
                            onChange={this.onChange}
                          />
                        </div>
                        <div className="input-field col s12">
                          <TextFieldGroupProfile
                            field="streetAddressOne"
                            value={streetAddressOne}
                            error={errors.streetAddressOne}
                            label="Street Address 1*"
                            onChange={this.onChange}
                          />
                        </div>
                        <div className="input-field col s12">
                          <TextFieldGroupProfile
                            field="streetAddressTwo"
                            value={streetAddressTwo}
                            error={errors.streetAddressTwo}
                            label="Street Address 2"
                            onChange={this.onChange}
                          />
                        </div>
                        <div className="input-field col s12 l4">
                          <TextFieldGroupProfile
                            field="cityId"
                            value={cityId}
                            error={errors.cityId}
                            label="City*"
                            onChange={this.onChange}
                          />
                        </div>

                        <div className="input-field col s12 l4">
                          <label className="xs-small active">State*</label>

                          <Dropdown
                            name="cState"
                            className="browser-default"
                            options={optionsState}
                            onChange={this._cSelect}
                            value={cDefaultOptionState}
                            placeholder="Select an option"
                          />
                          <span className={errors.stateIdError ? 'show invalid' : 'hide'}>
                            {errors.stateId}
                          </span>
                        </div>

                        <div className="input-field col s12 l4">
                          <TextFieldGroupProfile
                            field="zipCode"
                            value={zipCode}
                            error={errors.zipCode}
                            label="Zip Code*"
                            onChange={this.onChange}
                          />
                        </div>

                        <div className="row">
                          <div className="input-field col s12 m5">
                            <label className="active">Country*</label>
                            <Dropdown
                              name="cState"
                              className="browser-default"
                              options={optionsCountry}
                              onChange={this._cCountrySelect}
                              value={cDefaultOptionCountry}
                              placeholder="Select an option"
                            />
                          </div>

                          <div className="input-field col s12 m7">
                            <MaskInputNumber
                              field="phoneNumber"
                              label="Phone Number*"
                              value={phoneNumber}
                              error={errors.phoneNumber}
                              onChange={this.onChange}
                            />
                          </div>
                        </div>
                        <div className="input-field col s12">
                          <div className="mb-20">
                            <TextFieldGroupProfile
                              field="email"
                              label="Email*"
                              value={email}
                              error={errors.email}
                              onChange={this.onChange}
                              disable
                            />
                          </div>
                        </div>
                        <div className="input-field col s12 profile-username">
                          <div className="mb-20">
                            <span>Affiliate type :</span>
                            {' '}
                            {affiliateType}
                          </div>
                        </div>

                        <div className="input-field col s12">
                          <label className="xs-small active">Country*</label>
                          <Dropdown
                            name="cState"
                            className="browser-default"
                            options={optionsCountry1}
                            onChange={this._countrySelect}
                            value={cDefaultOptionCountry1}
                            placeholder="Select an option"
                          />
                          <span className={errors.countryNameError ? 'show invalid' : 'hide'}>
                            {errors.countryName}
                          </span>
                        </div>
                      </div>
                      <button
                        className="btn waves-effect waves-light primary-btn col s6 offset-s3"
                        type="submit"
                        name="action"
                      >
                        Update
                        <i className="material-icons">arrow_forward</i>
                      </button>
                    </div>
                    </div>
                  </div>
                </form>
                <ChangePassword />
              </div>
            </div>
          </div>
        </div>
          {userObject.userDto.parentAffiliateUser === "No" ?
          <div className="section-content partner-dashboard partner-referral">
          <div className="row">
            <div className="col s12">
              <h4 className="col s12 m9 manage-subuser">Manage Sub Users</h4>
              <div className="col s12 m3 grid-add-link">
                <Link className="add-partner-sub-user" to="/profile/addSubUsers">
                  Add Sub User
                </Link>
              </div>
            </div>
            <div className="referral-data partner-profile-sub-users">
              <div className="col s12">
              {GetAffiliateSubUserList1 && GetAffiliateSubUserList1.code === 200 ? (
                            <Table >
                                <TableHead>
                                    <TableRow>
                                        <CustomTableCell>First Name</CustomTableCell>
                                        <CustomTableCell >Last Name</CustomTableCell>
                                        <CustomTableCell >Phone Number</CustomTableCell>
                                        <CustomTableCell >Email Id</CustomTableCell>

                                    </TableRow>
                                </TableHead>

                                <TableBody className="p-table-body">{
                                    GetAffiliateSubUserList1.result ?
                                        GetAffiliateSubUserList1.result.map((item) => (
                                            <TableRow key={item.affiliateSubUserId} >
                                                <CustomTableCell >{item.firstName}</CustomTableCell>
                                                <CustomTableCell >
                                                    {item.lastName}
                                                </CustomTableCell>
                                        <CustomTableCell >{item.phoneNumber}</CustomTableCell>
                                                <CustomTableCell >{item.email}</CustomTableCell>

                                                <CustomTableCell > <Link
                                                    // to="/userDetail"
                                                    to={`/profile/update/${item.affiliateSubUserId}`}
                                                >
                                <i className="small material-icons">create</i>
                </Link><a
                                                  herf="#"
                                                  onClick={() =>
                                                    this.handleClickOpenDelete(
                                                      item.affiliateSubUserId,
                                                      item
                                                    )
                                                  }
                                                >
                                                  <i className="small material-icons">
                                                    delete_forever
                                                  </i>
                                                </a></CustomTableCell>
                                  
                                            </TableRow>
                                        ))
                                        : (<TableRow  >
                                            <CustomTableCell >No records</CustomTableCell></TableRow>)
                                }</TableBody>




                            </Table>) : GetAffiliateSubUserList1.code === 404 ? (

                                <Table >
                                    <TableHead>
                                        <TableRow>
                                            <CustomTableCell>First Name</CustomTableCell>
                                            <CustomTableCell >Last Name</CustomTableCell>
                                            <CustomTableCell >Phone Number</CustomTableCell>
                                            <CustomTableCell >Email Id</CustomTableCell>

                                        </TableRow>
                                    </TableHead>
                                    <TableRow  >
                                        <CustomTableCell >No records</CustomTableCell></TableRow>
                                </Table>
                            ) : ""}

                    {/* <TablePagination
                        component="div"
                        count={GetAffiliateSubUserList1 && GetAffiliateSubUserList1.result && GetAffiliateSubUserList1.result.totalCount ? GetAffiliateSubUserList1.result.totalCount : 0}
                        className="pagination-table"
                        rowsPerPage={rowsPerPage}
                        page={pageNumber}
                        backIconButtonProps={{
                            'aria-label': 'Previous Page',
                        }}
                        nextIconButtonProps={{
                            'aria-label': 'Next Page',
                        }}
                        onChangePage={this.handleChangePage}
                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    />
                    */}

                {/* <ReactTable
                  data={GetAffiliateSubUserList1}
                  columns={[
                    {
                      columns: [
                        {
                          Header: 'First Name',
                          accessor: 'firstName',
                        },
                        {
                          Header: 'Last Name',
                          id: 'lastName',
                          accessor: d => d.lastName,
                        },
                        {
                          Header: 'Email',
                          id: 'email',
                          accessor: d => d.email,
                          filterable: false,
                        },
                        {
                          Header: 'Phone',
                          id: 'phone',
                          accessor: d => d.phoneNumber,
                        },
                        {
                          Header: 'Actions',
                          id: 'link',
                          filterable: false,
                          accessor: d => d,
                          Cell: props => (
                            <div>
                              <Link
                                className="font-medium show-right-button"
                                to={`/affiliate/update/${
                                  props.value.affiliateSubUserId
                                  }`}
                              >
                                <i className="small material-icons">create</i>
                              </Link>
                              <a
                                herf="#"
                                onClick={() =>
                                  this.handleClickOpenDelete(
                                    props.value.affiliateSubUserId,
                                  )
                                }
                              >
                                <i className="small material-icons">
                                  delete_forever
                                </i>
                              </a>
                            </div>
                          ),
                        },
                      ],
                    },
                  ]}
                  defaultPageSize={10}
                  className="-striped -highlight"
                /> */}
              </div>
            </div>
          </div>
        </div>
        
          :
          ""
          }
        
        </div>
     ): (
      <div className="container">
          <SubuserUpdateAffiliate subUserId={localStorage.getItem('userId')} isprofile = { true} />
          <ChangePassword />
              
      </div>
     )}
     </span>
    );
  }
}

Profile.contextTypes = {
  router: PropTypes.object.isRequired,
};
const mapStateToProps = state => ({
  data: state.data,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getAffiliateUser,
      deleteAffiliatedSubUser,
      getAllAffiliatedUsers,
      getAllCountry,
      updateAffiliate,
      getStates,
      getCityByStateId,
      updateConsumerUser,
      getAllStates,
      checkEmailVerify,

    },
    dispatch,
  );

export default withAlert(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Profile),
);
